module.exports = __webpack_public_path__ + "static/img/cont43_01.d071404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_01.jpg
// module id = hnHy
// module chunks = 0